export default "__VITE_ASSET__ZoZgqOMX__"